import { Link } from 'react-router-dom'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import {
  NavbarContainer,
  NavItem,
  NavItems,
  NavLogo,
  LogoImage,
  Title,
  AppName,
  Div
} from './Navbar.styles'
import Logo from '../../assets/images/ABG_logo.jpg'
import Icon from '../Icon/Icon'
import { COLORS } from '../../constants'

const Navbar: React.FC = () => {
  type EnvType = 'DEV' | 'UAT' | 'PROD'

  const envColors: Record<EnvType, string> = {
    DEV: COLORS.dev,
    UAT: COLORS.uat,
    PROD: COLORS.gray
  }

  const deployedEnv: EnvType = (window.env?.API_ENV as EnvType) || 'PROD'

  const envColor = envColors[deployedEnv] || COLORS.gray

  return (
    <NavbarContainer $backgroundColor={envColor}>
      <Div>
        <NavLogo to="/">
          <LogoImage src={Logo} alt="ABG Logo" />
        </NavLogo>
        <AppName>ABG Truck Load Calculator</AppName>
      </Div>
      <NavItems>
        <Link to="/">
          <NavItem>
            <Icon icon={faHome} size="18px" color="inherit" />
            <Title>Home</Title>
          </NavItem>
        </Link>
      </NavItems>
    </NavbarContainer>
  )
}

export default Navbar
